import { ModelBase, NeoModel } from '@singularsystems/neo-core';

@NeoModel
export default class UpdateClientCommand extends ModelBase {
   
    public missingAccountId: number | null = null;

    public staticCurrencyId: number = 0;

    public clientNumber: string = "";

    public clientName: string = "";

    public staticServiceProviderFileGroupingId: number | null = null;

    public serviceProviderAccountNumber: string = "";

    public brokerDescription: string = "";

    public activeInactive: string = "";

    public isMappedFromMissingAccounts: boolean = false;

    public clientEntityTypeId: number | null = null;

    public clientEntityTypeName: string | null = null;

    public clientId: number = 0;
    
    public clientAccountId: number = 0;
}